import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const RelationshipTypeEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-link-relationship-editview-full" */ './src/ui/index.tsx'),
	),
	getPreloadProps: () => ({}),
});

export default RelationshipTypeEditViewEntryPoint;
